import {
    Text,
    Image,
    View
} from '@react-pdf/renderer';
import logo from '../../logo.png';
import defaultStyles from '../print-pdf/defaultStyles';
import { PrintDate } from '+/components/PrintDate';


const Logo = props => {


    const {
        date
    } = props;

    return (
        <div>
            <div>
                <View style={{
                    width: '160px',
                    marginLeft: '45%',
                    marginTop: 5
                }}>
                    <Image style={defaultStyles.logo_header} alt='logo' src={logo} />
                    <Text style={defaultStyles.title_header}>
                    Financial Report: {date}
                    </Text>
                </View>
            </div>
            <div style={{ marginLeft: '12px' }}>
                <PrintDate isForPDF={true} />
            </div>
        </div>

    );
};
const CoverPage = props => {

    const {
        date
    } = props;


    return (

        <View style={{
            //display: 'flex',
            //flexDirection: 'row',
            width: '100%'
        }}>

            <Logo date={date}/>
        </View>


    );
};

export default CoverPage;
